import React from 'react';
import { RenderCheckbox } from 'forms';
import { Field } from 'react-final-form';

interface Props {
    name: string;
    label?: string;
    disabled?: boolean;
}

export default function ModuleCheckbox(props: Props): React.ReactElement {
    const { name, label, disabled } = props;

    return (
        <Field
            component={RenderCheckbox as any}
            name={name}
            label={label}
            parse={(value): boolean => Boolean(value)}
            disabled={disabled}
        />
    );
}

ModuleCheckbox.defaultProps = {
    label: 'Module',
    disabled: false
};
